interface Company {
  name: string;
  logo: string;
}

export const companies: Company[] = [
  {
    name: 'Ola',
    logo: '/orgs/ola_opt.png',
  },
  {
    name: 'Whatfix',
    logo: '/orgs/whatfix_opt.png',
  },
  {
    name: 'Porter',
    logo: '/orgs/porter_opt.png',
  },
  {
    name: 'Jupiter',
    logo: '/orgs/jupiter_opt.png',
  },
  {
    name: 'Agnikul',
    logo: '/orgs/agnikul_opt.png',
  },
  {
    name: 'Rupeek',
    logo: '/orgs/rupeek_opt.png',
  },
  {
    name: 'Rapido',
    logo: '/orgs/rapido_opt.png',
  },
  {
    name: 'Fareye',
    logo: '/orgs/fareye_opt.png',
  },
  {
    name: 'Medibuddy',
    logo: '/orgs/medibuddy_opt.png',
  },
  {
    name: 'Apps for Bharat',
    logo: '/orgs/apps_for_bharat_opt.png',
  },
  {
    name: 'Pixis',
    logo: '/orgs/pixis_opt.png',
  },
  {
    name: 'Chalo',
    logo: '/orgs/chalo_opt.png',
  },
  {
    name: 'Mudrex',
    logo: '/orgs/mudrex_opt.png',
  },
  {
    name: 'Raise Financial Services',
    logo: '/orgs/raise_opt.png',
  },
  {
    name: 'Animall',
    logo: '/orgs/animall_opt.png',
  },
  {
    name: 'Basic Home Loans',
    logo: '/orgs/basic_home_loans_opt.png',
  },
  {
    name: 'Gokwik',
    logo: '/orgs/gokwik_opt.png',
  },
  {
    name: 'Quizizz',
    logo: '/orgs/quizizz_opt.png',
  },
  {
    name: 'Grayquest',
    logo: '/orgs/grayquest_opt.png',
  },
  {
    name: 'Fab Hotels',
    logo: '/orgs/fab_hotels_opt.png',
  },
  {
    name: 'Zingbus',
    logo: '/orgs/zingbus_opt.png',
  },
  {
    name: 'Rigi',
    logo: '/orgs/rigi_opt.png',
  },
];
